import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d377ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "padding-left-20 padding-right-20" }
const _hoisted_2 = { class: "line-height-20" }
const _hoisted_3 = {
  key: 0,
  style: {"line-height":"1.5em"},
  class: "margin-top-5"
}
const _hoisted_4 = {
  key: 1,
  style: {"line-height":"1.5em"},
  class: "margin-top-5 operation-drawer-remark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_empty = _resolveComponent("empty")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, _mergeProps(_ctx.$attrs, {
    title: _ctx.title,
    modelValue: _ctx.modelValue,
    "destroy-on-close": true
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.list.length)
          ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: index,
                    timestamp: item.time,
                    placement: "top",
                    color: _ctx.getColor(index)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(item.user) + " ", 1),
                        (item.content)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.content), 1))
                          : _createCommentVNode("", true),
                        (item.remark)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.remark), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["timestamp", "color"]))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_empty, { key: 1 }))
      ])
    ]),
    _: 1
  }, 16, ["title", "modelValue"]))
}